import { render, staticRenderFns } from "./SearchGlobal.vue?vue&type=template&id=744c4a08&scoped=true"
import script from "./SearchGlobal.vue?vue&type=script&lang=js"
export * from "./SearchGlobal.vue?vue&type=script&lang=js"
import style0 from "./SearchGlobal.vue?vue&type=style&index=0&id=744c4a08&prod&scoped=true&lang=css"
import style1 from "./SearchGlobal.vue?vue&type=style&index=1&id=744c4a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c4a08",
  null
  
)

export default component.exports